import React, { FC } from 'react';

import { PaletteColor } from '@utils/types';

import { Label } from './BorderedLabelStyle';

interface BorderedLabelProps {
  text: string;
  backgroundColor?: PaletteColor;
  color?: PaletteColor;
  borderColor?: PaletteColor;
}

const BorderedLabel: FC<BorderedLabelProps> = ({
  text,
  backgroundColor,
  color,
  borderColor,
}) => (
  <Label
    backgroundColor={backgroundColor}
    color={color}
    borderColor={borderColor}
  >
    {text}
  </Label>
);

export default BorderedLabel;
